<i18n>
{
  "en": {
    "label": {
      "mail": "email",
      "currentPassword": "current password",
      "password": "password",
      "passwordConfirm": "password (confirm)",
      "instagramUserName": "Instagram user name (fixed)",
      "submitBtn": "Back to Top",
      "twUserName": "Twitter user name (fixed)",
      "userName": "user name (fixed)",
      "updateBtn": "Update",
      "cancelBtn": "Cancel",
      "dialogTtitleEmail": "Send confirm mail",
      "dialogMessageEmail": "Send confirmation email to new email address.<br />Click the link in the confirmation email to complete the change.",

      "dialogTtitlePassword": "Confirm Dialog",
      "dialogMessagePassword": "Password update completed",
      "dialogOkButton": "OK"
    },
    "message": {
      "currentPasswordError": "Current password error"
    }
  },
  "ja": {
    "label": {
      "mail": "メールアドレス",
      "currentPassword": "現在のパスワード",
      "password": "パスワード",
      "passwordConfirm": "確認用パスワード",
      "instagramUserName": "Instagramユーザーネーム（変更不可）",
      "twUserName": "Twitterユーザ名（変更不可）",
      "userName": "ユーザ名（変更不可）",
      "submitBtn": "マイページへ戻る",
      "updateBtn": "更新",
      "cancelBtn": "キャンセル",
      "dialogTtitleEmail": "メールアドレス変更確認",
      "dialogMessageEmail": "メールアドレスの確認のため変更後メールアドレスへ確認メールを送信しました。確認メール中のリンクをクリックし変更を完了してください。",

      "dialogTtitlePassword": "パスワード変更確認",
      "dialogMessagePassword": "パスワードを変更しました。",
      "dialogOkButton": "OK"
    },
    "message": {
      "currentPasswordError": "現在のパスワードが不正です。"
    }
  }
}
</i18n>

<template>
  <div>
    <v-card class="items-area">
      <v-flex>
        <div v-show="userName">
          <v-flex class="item-wrapper none-hover">
            <v-flex class="item-header">
              {{ this.$t('label.userName') }}
            </v-flex>
            <v-flex class="item">
              <v-flex id="userName-text" style="word-break: break-all">
                {{ userName }}
              </v-flex>
            </v-flex>
          </v-flex>
          <v-divider></v-divider>
        </div>

        <v-flex @click="edit('email')" class="item-wrapper">
          <v-flex class="item-header">
            {{ this.$t('label.mail') }}
          </v-flex>
          <v-flex class="item">
            <v-flex
              v-show="!isShowEmailInput"
              id="mail-text"
              style="word-break: break-all"
            >
              {{ email }}
            </v-flex>
            <v-flex v-show="isShowEmailInput">
              <p
                class="vee-error"
                style="color: #F87060; font-size: 1rem;"
                v-if="errors.first('email')"
              >
                {{ errors.first('email') }}
              </p>
              <TextInput
                id="mail-input"
                class="item-input"
                name="email"
                v-model="email"
                :placeholderValue="this.$t('label.mail')"
                v-validate="'required|email|max:254'"
                :readonly="inProgress"
                autocomplete="off"
              ></TextInput>
              <v-layout>
                <SubmitBtn
                  :colorCode="submitBtn.colorCode"
                  @click.stop="submit('email')"
                  :autoSpread="true"
                  style="font-size: 1rem;"
                  :disabled="
                    this.keepEmail == this.email || errors.has('email')
                  "
                >
                  <strong>{{ this.$t('label.updateBtn') }}</strong>
                </SubmitBtn>
                <SubmitBtn
                  :colorCode="submitBtn.colorCode"
                  @click.stop="cancel('email')"
                  :autoSpread="true"
                  style="font-size: 1rem;"
                >
                  <strong>{{ this.$t('label.cancelBtn') }}</strong>
                </SubmitBtn>
              </v-layout>
            </v-flex>
          </v-flex>
        </v-flex>
        <v-divider></v-divider>
        <v-flex @click="edit('password')" class="item-wrapper">
          <v-flex class="item-header" v-show="!isShowPasswordInput">
            {{ this.$t('label.password') }}
          </v-flex>
          <v-flex class="item">
            <v-flex v-show="!isShowPasswordInput" id="password-text">
              **********
            </v-flex>
            <v-flex v-show="isShowPasswordInput">
              <v-flex>

                <v-flex
                  class="item-header"
                  style="margin-top: 0px; padding-top: 0px;"
                >
                  {{ this.$t('label.currentPassword') }}
                </v-flex>
                <p
                  class="vee-error"
                  style="color: #F87060; font-size: 1rem;"
                  v-if="errors.first('currentPassword')"
                >
                  {{ errors.first('currentPassword') }}
                </p>
                <TextInput
                  id="password-input"
                  class="item-input"
                  v-model="currentPassword"
                  :placeholderValue="this.$t('label.currentPassword')"
                  type="password"
                  name="currentPassword"
                  v-validate="'required|min:8|max:30|password'"
                  :readonly="inProgress"
                  autocomplete="off"
                  :data-vv-as="this.$t('label.currentPassword')"
                ></TextInput>


                <v-flex
                  class="item-header"
                  style="margin-top: 0px; padding-top: 0px;"
                >
                  {{ this.$t('label.password') }}
                </v-flex>
                <p
                  class="vee-error"
                  style="color: #F87060; font-size: 1rem;"
                  v-if="errors.first('password')"
                >
                  {{ errors.first('password') }}
                </p>
                <TextInput
                  id="password-input"
                  class="item-input"
                  v-model="password"
                  :placeholderValue="this.$t('label.password')"
                  type="password"
                  name="password"
                  v-validate="'required|min:8|max:30|password'"
                  :readonly="inProgress"
                  autocomplete="off"
                  ref="password"
                ></TextInput>


                <v-flex
                  class="item-header"
                  style="margin-top: 0px; padding-top: 0px;"
                >
                  {{ this.$t('label.passwordConfirm') }}
                </v-flex>
                <p
                  class="vee-error"
                  style="color: #F87060; font-size: 1rem;"
                  v-if="errors.first('passwordConfirm')"
                >
                  {{ errors.first('passwordConfirm') }}
                </p>

                <TextInput
                  id="passwordConfirm-input"
                  class="item-input"
                  v-model="passwordConfirm"
                  :placeholderValue="this.$t('label.passwordConfirm')"
                  type="password"
                  name="passwordConfirm"
                  v-validate="'required|min:8|max:30|confirmed:password'"
                  :readonly="inProgress"
                  autocomplete="off"
                ></TextInput>
              </v-flex>
              <v-layout align-center>
                <SubmitBtn
                  :colorCode="submitBtn.colorCode"
                  @click.stop="submit('password')"
                  :autoSpread="true"
                  style="font-size: 1rem;"
                  :disabled="
                    !this.password ||
                      !this.passwordConfirm ||
                      errors.has('password') ||
                      errors.has('passwordConfirm')
                  "
                >
                  <strong>{{ this.$t('label.updateBtn') }}</strong>
                </SubmitBtn>
                <SubmitBtn
                  :colorCode="submitBtn.colorCode"
                  @click.stop="cancel('password')"
                  :autoSpread="true"
                  style="font-size: 1rem;"
                >
                  <strong>{{ this.$t('label.cancelBtn') }}</strong>
                </SubmitBtn>
              </v-layout>
            </v-flex>
          </v-flex>
        </v-flex>
        <v-divider></v-divider>

        <div v-show="instagramUserName">
          <v-flex class="item-wrapper none-hover">
            <v-flex class="item-header">
              {{ this.$t('label.instagramUserName') }}
            </v-flex>
            <v-flex class="item">
              <v-flex id="instagramUserName-text" style="word-break: break-all">
                {{ instagramUserName }}
              </v-flex>
            </v-flex>
          </v-flex>
          <v-divider></v-divider>
        </div>

        <div v-show="twUserName">
          <v-flex class="item-wrapper none-hover">
            <v-flex class="item-header">
              {{ this.$t('label.twUserName') }}
            </v-flex>
            <v-flex class="item">
              <v-flex id="twUserName-text" style="word-break: break-all">
                {{ twUserName }}
              </v-flex>
            </v-flex>
          </v-flex>
          <v-divider></v-divider>
        </div>
      </v-flex>
      <br />
      <SubmitBtn
        :colorCode="submitBtn.colorCode"
        @click="$router.push('/cp/' + getCampaignCode() + '/me')"
        :autoSpread="true"
      >
        <strong>{{ $t('label.submitBtn') }}</strong>
      </SubmitBtn>
    </v-card>
    <ConfirmDialog
      @click="closeConfirmDialog"
      :dialog="isOpenConfirmDialog"
      :title="dialogTitle"
      :message="dialogMessage"
      :okButton="dialogOkButton"
    ></ConfirmDialog>
  </div>
</template>

<script>
import SubmitBtn from '@/components/atoms/SubmitBtn.vue';
import TextInput from '@/components/atoms/TextInput.vue';
import { Auth, Me } from '@/api';
import StorageManager from '@/utils/StorageManager';
import ConfirmDialog from '../dialogs/ConfirmDialog.vue';

export default {
  components: {
    SubmitBtn,
    TextInput,
    ConfirmDialog
  },
  data() {
    return {
      isOpenDialog: false,
      isOpenConfirmDialog: false,

      inProgress: false,
      submitBtn: {
        colorCode: 'primary'
      },
      isEditing: false,
      email: '',
      currentPassword: '',
      password: '',
      passwordConfirm: '',
      instagramUserName: '',
      twUserName: '',
      userName: '',

      keepEmail: '',
      keepInstagramUserName: '',

      isShowEmailInput: false,
      isShowPasswordInput: false,

      dialogTitle: '',
      dialogMessage: '',
      dialogOkButton: '',

      campaignCode: '',

      errorMessage: '',
      isBtnDFlex: this.$vuetify.breakpoint.smAndDown,
      rules: {
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail.';
        }
      }
    };
  },
  methods: {
    edit(editType) {
      if (!this.isEditing) {
        this.isEditing = true;
        if (editType == 'email') {
          this.isShowEmailInput = true;
          this.keepEmail = this.email;
        } else if (editType == 'password') {
          this.isShowPasswordInput = true;
        }
      }
    },
    async submit(editType) {
      this.isEditing = false;
      if (editType == 'email') {
        this.isShowEmailInput = false;
        this.updateEmail();
      } else if (editType == 'password') {
        //現在のパスワード確認用トークンの取得
        this.campaignCode = this.getCampaignCode();
        const temporaryToken = await Auth.prepare({ campaignHash: this.campaignCode })
        .then(result => {
          return result.result.auth.token;
        })
        //現在のパスワードがあっているかを確認
        Auth.checkPassword({ email: this.email, password: this.currentPassword, temporaryToken: temporaryToken })
          .then((result) => {
            //現在のパスワードがあっていたので、新パスワードに変更
            this.isShowPasswordInput = false;
            this.updatePassword();
          })
          .catch((error) => {
            //現在のパスワードが間違っていたので、エラーを表示
            this.$validator.errors.add({
              field: 'currentPassword',
              msg: this.$t('message.currentPasswordError')
            });
          });
        /*
        */
      }
    },
    cancel(editType) {
      this.isEditing = false;
      if (editType == 'email') {
        this.isShowEmailInput = false;
        this.email = this.keepEmail;
      } else if (editType == 'password') {
        this.isShowPasswordInput = false;
        this.password = '';
        this.passwordConfirm = '';
      }
    },
    getCampaignCode: () => {
      return StorageManager.getItem('CAMPAIGN_CODE_SESSION_KEY');
    },

    /**
     * パスワード変更処理
     */
    updatePassword() {
      Me.changePassword(this.password).finally(() => {
        this.password = '';
        this.passwordConfirm = '';
      });

      //パスワード変更ダイアログを表示
      this.dialogTitle = this.$t('label.dialogTtitlePassword');
      this.dialogMessage = this.$t('label.dialogMessagePassword');
      this.dialogOkButton = this.$t('label.dialogOkButton');
      this.isOpenConfirmDialog = true;
    },
    /**
     * メール変更処理
     */
    async updateEmail() {
      await Auth.verifyEmail({ email: this.email });
      //メール変更確認ダイアログ表示
      this.dialogTitle = this.$t('label.dialogTtitleEmail');
      this.dialogMessage = this.$t('label.dialogMessageEmail');
      this.dialogOkButton = this.$t('label.dialogOkButton');
      this.isOpenConfirmDialog = true;

      //画面表示上は古いアドレスの表示に戻す
      //送信されたURLをクリックした上で、本画面に戻れば、
      //更新後のメールアドレスが表示される
      this.email = this.keepEmail;
    },
    closeConfirmDialog() {
      //確認ダイアログを閉じる処理
      this.isOpenConfirmDialog = false;
      this.$nextTick(function() {});
    },

    getCampaignCode: () => {
      return StorageManager.getItem('CAMPAIGN_CODE_SESSION_KEY');
    }
  },
  mounted: function() {
    Me.fetchDataAtOnce().then(data => {
      this.email = data.me.email;
      this.instagramUserName = data.me.igName;
      this.twUserName = data.me.twName;
      this.userName = data.me.name;
    });
  }
};
</script>

<style scoped lang="stylus">
.items-area {
  padding: 32px;
}

.item-wrapper {
  text-align: left;
  margin: 0px;
  padding: 16px;
}

.item-wrapper:hover {
  background-color: #eeeeee;
}

.none-hover:hover {
  background-color: transparent;
}

.item-header {
  color: #999999;
  margin: 8px 0px;
  font-size: 1rem;
}

.item {
  margin: 8px 0px;
  padding: 0px;
  font-size: 1.4rem;
}

.item-input {
  margin: 8px 0px;
  padding: 0px;
  font-size: 1rem;
}
</style>
